module.exports = __webpack_public_path__ + "img/orders-table-file.8595ff23.svg";